<!-- Localized -->
<template>
<card-template
  :item="item"
  :selected="selected"
  :compact="compact"
>
  <template #content>
    <div class="leading-5">
      <div class="flex gap-2">
        <b class="font-medium">{{ item.creator }}</b>
        <p>{{ $t('components.dashboard.card.created_note') }}</p>
      </div>

      <div v-if="filteredUsersToNotifyList.length > 0" class="flex gap-2">
        <b class="font-medium">{{ $t('components.dashboard.card.notify') }}</b>
        <p class="flex gap-1">
          <span
            v-for="(el, index) in filteredUsersToNotifyList"
            :key="`notify-${index}`"
            v-tooltip.top.center="{ content: el?.email, classes: 'bg-base-content-300 p-1 rounded-md text-white-text' }"
            class="inline-flex"
          >
            {{ el?.username }}
            <checkbox v-if="el?.acknowledge" isAck class="w-3 ml-1 pointer-events-none"/>
            <span v-if="index < filteredUsersToNotifyList.length - 1">, </span>
          </span>
        </p>
      </div>

      <div class="flex gap-2 pt-2">
        <p><b class="text-gray-700 pr-3">{{ $t('components.dashboard.card.note') }}</b>{{ item.note_text }}</p>
      </div>

      <div v-if="isAdditionalUsersListShown" class="flex gap-2">
        <b class="font-medium">{{ $t('components.dashboard.card.acknowledged_by') }}</b>
        <p class="flex gap-1">
          <span
            v-for="(el, index) in acknowledgedUsersList"
            :key="`acknowledge-${index}`"
          >
            {{ el?.username }}
            <span v-if="index < acknowledgedUsersList.length - 1">, </span>
          </span>
        </p>
      </div>

      <div v-if="isAdditionalUsersListShown" class="flex gap-2">
        <b class="font-medium">{{ $t('components.dashboard.card.additionally_acknowledged_by') }}</b>
        <p  class="flex gap-1">
          <span
            v-for="(el, index) in additionalUsersList"
            :key="`additional-${index}`"
          >
            {{ el?.username }}
            <span v-if="index < additionalUsersList.length - 1">, </span>
          </span>
        </p>
      </div>
    </div>
  </template>

  <template #content-compact>
    <div class="property property--subject">
        {{ item.note_text }}
      </div>
      <div class="property property--date">
        {{ formateDateRow(item.event_timekey) }}
      </div>
    </template>
</card-template>
</template>

<script>
import { formatUtcDate } from "@shared/utils/dateTime";
import cardTemplate from "./card-base-template.vue";
const checkbox = () => import("@/components/dashboard-components/checklist/components/checkbox.vue");

export default {
  name: 'card-note',

  components: {
    cardTemplate,
    checkbox
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      required: false,
    },
    compact: {
      type: Boolean,
      required: false,
    },
  },

  computed: {
    // TODO Uncomment if we need to show additional users list
    isAdditionalUsersListShown() {
      return false;
      // return this.additionalUsersList.length > 0
    },

    filteredUsersToNotifyList() {
      return this.usersToNotifyList;
    },
    usersToNotifyList() {
      return this.item.notify_user ?? [];
    },
    acknowledgedUsersList() {
      return this.item.notify_user?.filter(el => el?.acknowledge) ?? [];
    },
    additionalUsersList() {
      return this.item.additional_user ?? [];
    },
  },

  methods: {
    formateDateRow(date){
      return formatUtcDate(date);
    }
  },
}
</script>
